export default "__VITE_ASSET__fa580aa2__"